<template>
  <!-- 法援申请-申请须知 -->
  <div class="eprights-cont">
    <div class="left-tabs">
      <a class="active" @click="gotoAid">法援申请</a>
      <a @click="gotoHistory">历史援助</a>
    </div>
    <div class="right-laws">
      <h3 class="titleh3">填写申请信息</h3>
      <div class="applay-info">
        <a-form-model
          ref="aidForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item ref="name" label="标题" prop="title">
            <a-input v-model="form.title" placeholder="请填写" />
          </a-form-model-item>
          <a-form-model-item label="姓名" prop="creator_name">
            <a-input v-model="form.creator_name" placeholder="请填写" />
          </a-form-model-item>
          <a-form-model-item label="性别" prop="creator_sex">
            <a-select
              v-model="form.creator_sex"
              placeholder="请选择"
              style="width: 100%"
            >
              <a-select-option
                v-for="(value, key, index) in sexOptions"
                :key="'sex_' + value.value"
                :value="value.value"
                >{{ value.name }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="手机号码" prop="creator_mobile_number">
            <a-input
              v-model="form.creator_mobile_number"
              placeholder="请填写"
            />
          </a-form-model-item>
          <a-form-model-item label="证件类型" prop="creator_certificate_type">
            <a-select
              v-model="form.creator_certificate_type"
              placeholder="请选择"
              style="width: 100%"
              :default-value="1"
            >
              <a-select-option
                v-for="(value, key, index) in certifTypeOptions"
                :key="'certifType_' + value.value"
                :value="value.value"
                >{{ value.name }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="证件号码" prop="creator_certificate_number">
            <a-input
              v-model="form.creator_certificate_number"
              placeholder="请填写"
            />
          </a-form-model-item>
          <a-form-model-item label="工作单位" prop="creator_work_organization">
            <a-input
              v-model="form.creator_work_organization"
              placeholder="请填写"
            />
          </a-form-model-item>
          <a-form-model-item label="籍贯" prop="creator_native_place">
            <a-input v-model="form.creator_native_place" placeholder="请填写" />
          </a-form-model-item>
          <a-form-model-item label="住所地" prop="creator_residence">
            <a-input v-model="form.creator_residence" placeholder="请填写" />
          </a-form-model-item>
          <a-form-model-item label="援助对象类型" prop="aid_type">
            <a-select
              v-model="form.aid_type"
              placeholder="请选择"
              style="width: 100%"
            >
              <a-select-option
                v-for="(value, key, index) in aidTypeOptions"
                :key="'aid_type_' + value.value"
                :value="value.value"
                >{{ value.name }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            label="身份证明"
            prop="creator_identity_att_url"
            ref="fileRef"
            validateStatus="success"
          >
<!--            <a-upload-->
<!--              :action="BASEURL+'api/annex/uploads'"-->
<!--              :before-upload="beforeUpload"-->
<!--              name="Attachment"-->
<!--              :data="{ path: 'file' }"-->
<!--              @change="handleChange"-->
<!--              v-model="form.creator_identity_att_url"-->
<!--            >-->
<!--              <a-button>-->
<!--                <a-icon type="upload" />-->
<!--                选择上传附件-->
<!--              </a-button>-->
<!--            </a-upload>-->
            <one-upload
              v-model="form.creator_identity_att_url"
              list-type=""
              @upload="handleChange"
            ></one-upload>
          </a-form-model-item>
          <a-form-model-item label="对方当事人姓名或名称" prop="opposite_name">
            <a-input v-model="form.opposite_name" placeholder="请填写" />
          </a-form-model-item>
          <a-form-model-item label="对方当事人住所地" prop="opposite_residence">
            <a-input v-model="form.opposite_residence" placeholder="请填写" />
          </a-form-model-item>
          <a-form-model-item
            label="对方当事人联系方式"
            prop="opposite_contacts"
          >
            <a-input v-model="form.opposite_contacts" placeholder="请填写" />
          </a-form-model-item>
          <a-form-model-item label="申请事项类型" prop="matter_type">
            <a-select
              v-model="form.matter_type"
              placeholder="请选择"
              style="width: 100%"
            >
              <a-select-option
                v-for="(value, key, index) in matterTypeOptions"
                :key="'matter_type_' + value.value"
                :value="value.value"
                >{{ value.name }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="申请事项基本情况" prop="matter_info">
            <a-textarea
              v-model="form.matter_info"
              placeholder="请填写"
              :auto-size="{ minRows: 2, maxRows: 5 }"
            />
          </a-form-model-item>
          <a-form-model-item
            ref="accept_unit_id"
            label="提交对象"
            prop="accept_unit_id"
          >
            <a-cascader
              :options="unitOptions"
              v-model="form.accept_unit_id"
              change-on-select
              placeholder="请选择"
              @change="changeUnit"
            ></a-cascader>
          </a-form-model-item>

          <!-- <a-form-model-item label="事件发生地" prop="matter_site">
            <a-input v-model="form.matter_site" placeholder="请填写" />
          </a-form-model-item> -->

          <a-form-model-item label="相关材料" prop="att_url">
            <a-upload
              v-decorator="[
                'upload',
                { valuePropName: 'fileList', getValueFromEvent: normFile },
              ]"
              name="Attachment"
              :data="{ path: 'file' }"
              :action="BASEURL+'api/annex/uploads'"
              v-model="form.att_url"
              @change="handleUpload"
            >
              <a-button>
                <a-icon type="upload" />
                选择上传附件
              </a-button>
            </a-upload>
          </a-form-model-item>
          <!--        <a-form-model-item label="相关材料" prop="material">-->
          <!--          <a-upload-->
          <!--            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"-->
          <!--            :default-file-list="form.fileList"-->
          <!--          >-->
          <!--            <a-button>-->
          <!--              <a-icon type="upload"/>-->
          <!--              选择上传附件-->
          <!--            </a-button>-->
          <!--          </a-upload>-->
          <!--        </a-form-model-item>-->
          <!--        <a-form-model-item label="身份证明" prop="material">-->
          <!--          <a-upload-->
          <!--            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"-->
          <!--            :default-file-list="form.fileList"-->
          <!--          >-->
          <!--            <a-button>-->
          <!--              <a-icon type="upload"/>-->
          <!--              选择上传附件-->
          <!--            </a-button>-->
          <!--          </a-upload>-->
          <!--        </a-form-model-item>-->
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button type="primary" @click="onSubmit"> 提交</a-button>
            <a-button style="margin-left: 10px" @click="resetForm">
              重置
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>
<script>
import {saveAid} from '@/api/aid';
import {getDeptTree} from '@/api/category';
import {getCurrentUser} from '@/api/login';
import OneUpload from "../../../components/Upload/OneUpload";

export default {
  name: 'ApplicationGuide',
  components: {OneUpload},
  data() {
    const validateNameCheck = (rule, value, callback) => {
      let num =0;
      num=value.length;
      // for (var i = 0; i < value.length; i++) {
      //   if (/[\u4e00-\u9fa5]/.test(value[i])) {
      //     num += 2
      //   } else {
      //     num++
      //   }
      // }
      // console.log(num)
      if (num > 20) {
        callback(new Error('标题最多20个文字！'))
      } else {
        callback()
      }
    };
    const validatePhoneCheck = (rule, value, callback) => {
      // 定义正则表达式
      const phoneRegex = /^(?:1(?:3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-9]))\d{8}$/;
      let num =0;
      num=value.length;
      // for (var i = 0; i < value.length; i++) {
      //   if (/[\u4e00-\u9fa5]/.test(value[i])) {
      //     num += 2
      //   } else {
      //     num++
      //   }
      // }
      // console.log(num)
      if (!phoneRegex.test(value)) {
        callback(new Error('手机号码校验不正确！'))
      } else {
        callback()
      }
    };
    return {
      accept_unit_id: [],
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      fileList: [],
      form: {
        creator_mobile_number: '', //手机号\
        creator_certificate_number: '',
        creator_name: '', //姓名
        creator_certificate_type: 1,
        accept_unit_id: []
      },
      rules: {
        title: [{required: true, message: '请输入标题', trigger: 'blur'},{ validator: validateNameCheck, trigger: 'blur' }],
        creator_name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        accept_unit_id: [
          {required: true, message: '请选择提交对象', trigger: 'change'},
        ],
        creator_sex: [
          {required: true, message: '请选择性别', trigger: 'change'},
        ],
        creator_mobile_number: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },{ validator: validatePhoneCheck, trigger: 'blur' }
        ],
        creator_certificate_type: [
          { required: true, message: '请选择证件类型', trigger: 'change' },
        ],
        creator_certificate_number: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
        ],
        creator_work_organization: [
          { required: true, message: '请输入工作单位', trigger: 'blur' },
        ],
        matter_site: [
          { required: true, message: '请输入事件发生地', trigger: 'blur' },
        ],
        creator_native_place: [
          { required: true, message: '请输入籍贯', trigger: 'blur' },
        ],
        creator_residence: [
          { required: true, message: '请输入住所地', trigger: 'blur' },
        ],
        aid_type: [
          { required: true, message: '请选择援助对象类型', trigger: 'change' },
        ],
        // creator_identity_att_url: [
        //   { required: true, message: '请上传身份证明文件', trigger: 'blur' },
        //   // {validator:(rule, value, callback)=>{
        //   //     setTimeout(() => {
        //   //       this.$refs.fileRef.clearValidate();
        //   //     }, 30);
        //   //   if (this.form.creator_identity_att_url) {
        //   //     callback();
        //   //   } else {
        //   //     callback("请上传身份证明文件");
        //   //   }
        //   //   }}
        // ],
        opposite_name: [
          { required: true, message: '请输入对方当事人姓名或名称', trigger: 'blur' },
        ],
        opposite_residence: [
          {required: true, message: '请输入对方当事人住所地', trigger: 'blur',},
        ],
        opposite_contacts: [
          {required: true, message: '请输入对方当事人联系方式', trigger: 'blur',},
        ],
        accept_unit: [
          { required: true, message: '请选择提交对象', trigger: 'change' },
        ],
        matter_type: [
          { required: true, message: '请选择申请事项类型', trigger: 'change' },
        ],
        matter_info: [
          {
            required: true,
            message: '请输入申请事项基本情况',
            trigger: 'blur',
          },
        ],
        // att_rel_id: [
        //   { required: true, message: '请上传相关材料', trigger: 'change' },
        // ],
      },
      aidTypeOptions: [],
      matterTypeOptions: [],
      sexOptions: null,
      certifTypeOptions: [],
      unitOptions: [],
      user_sex: '',
    };
  },
  created() {
    this.initCategory();
  },
  mounted() {
    let webId = JSON.parse(localStorage.getItem('webid'))
    if(webId == null || webId == "1"){
      this.form.accept_unit_id = []
    }else{
      this.form.accept_unit_id = [`${webId}`]
    }
    this.$forceUpdate()
  },
  methods: {
    async initCategory() {
      this.aidTypeOptions = this.$store.state.categoryOption.AidType;
      this.matterTypeOptions = this.$store.state.categoryOption.AidMatterType;
      this.sexOptions = this.$store.state.categoryOption.Sex;
      this.certifTypeOptions = this.$store.state.categoryOption.CertificateType;
      getDeptTree().then((res) => {
        // 修改时间2022/3/25
        // this.unitOptions = res;
        this.unitOptions = res[0].children;
      });
      getCurrentUser().then((res) => {
        this.form.creator_name = res.name;
        const sex = res.sex;
        if (sex == 1) {
          this.form.creator_sex = 1;
        } else if (sex == 0) {
          this.form.creator_sex = 2;
        }
        if (res.mobile) {
          this.form.creator_mobile_number = res.mobile;
        }
        if (res.cardid) {
          this.form.creator_certificate_number = res.cardid;
        }
      });
    },
    async onSubmit() {
      this.$refs.aidForm.validate(async (valid) => {
        if (valid) {
          // alert('submit!');
          console.log(this.form);
          this.form.accept_unit_id = this.form.accept_unit_id[this.form.accept_unit_id.length-1]
          await saveAid(this.form);
          this.$message.success('提交成功');
          this.resetForm();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.aidForm.resetFields();
      this.fileList = [];
    },
    gotoAid() {
      this.$router.push({ name: 'ApplicationGuide' });
    },
    gotoHistory: function () {
      this.$router.push({ name: 'HistoryAid' });
    },
    selectUnitClick(v) {
      console.log(v);
    },
    changeUnit(ids) {
      console.log(ids)
      // 修改时间2022/3/25
      // this.form.accept_unit_id = ids[ids.length - 1];
      // this.form.accept_unit_id = ids[0];
    },
    normFile(e) {
      console.log('Upload event:', e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    beforeUpload() {},
    handleChange(info) {
      // if (info.file.status === 'done') {
      //   setTimeout(() => {
      //     this.$refs.fileRef.clearValidate();
      //   }, 30);
      //   let img_url =
      //     info.file.response.data.items[0].file_path +
      //     '/' +
      //     info.file.response.data.items[0].file_name;
      //   this.form.creator_identity_att_url = img_url;
      // }

      console.log(123);
      this.$refs.fileRef.onFieldChange();
    },
    handleUpload(info) {
      if (info.file.status === 'done') {
        let img_url =
          info.file.response.data.items[0].file_path +
          '/' +
          info.file.response.data.items[0].file_name;
        this.form.att_url = img_url;
      }
    },
  },
};
</script>
<style scoped>
.eprights-cont {
  display: flex;
}

.left-tabs {
  width: 260px;
  text-align: center;
  padding-top: 20px;
}

.left-tabs a {
  display: inline-block;
  width: 220px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-size: 18px;
  color: #666;
  background: #fafbfc;
  border: 1px solid #d9dfe8;
  box-sizing: border-box;
}

.left-tabs a + a {
  margin-top: 10px;
}

.left-tabs a.active {
  color: #0079df;
  background: #f3f9ff;
  border: 1px solid #78c1ff;
}

.right-laws {
  flex: 1;
  padding-top: 10px;
  padding-right: 20px;
}

.applay-info {
  border: 1px solid #d9dfe8;
  padding: 0 20px;
}

.m-applay {
  margin-bottom: 0;
  padding: 15px 20px;
}

.m-applay li {
  list-style: none;
  line-height: 35px;
}

span.red {
  color: #f00;
}

.applay-info .ant-form {
  padding-top: 20px;
}
</style>
